export default "__VITE_ASSET__D4IkUL9Q__"